import { useEffect, useState, useMemo, MouseEvent } from 'react';
import { SetURLSearchParams, useSearchParams } from 'react-router-dom';
import { SwiperTab } from '@components/tab/SwiperTab';
import { GeneralTab } from '@components/tab/GeneralTab';
import { selectL10N } from '@features/ui/UiSlice';
import { ALIAS, DEVICE_TYPE, ROUTE, SEARCH_PARAMS } from '@constants/index';
import { getDevice, getInitialUrl } from '@utils/index';
import { useOption } from '@hooks/useOption';
import { useAppSelector } from '@hooks/defineRtkTypedHook';
import { useResize } from '@hooks/useResize';
import { ITabData } from '@components/tab/tabType';

const setTabData = (data: any, alias: {[key: string]: string}, searchParams: URLSearchParams, serviceAlias: string): ITabData[] => {
    if(!Array.isArray(data)) {
        return [];
    } 

    return data?.map(v => ({
        key: v?.key,
        type: 'ROUTE',
        title: alias[v?.l10nKey],
        url: getInitialUrl({
            serviceAlias, 
            alias: v?.key, 
            url: v?.url, 
            searchParams
        })
    }));
}

export const Tab = () => {
    const device = getDevice();
    const option = useOption();
    const { serviceAlias } = option;
    const { alias } = useAppSelector(selectL10N) || {};
    const { isPcWidth } = useResize();
    const [searchParams, setSearchParams] = useSearchParams();
    const route = serviceAlias ? useMemo(() => ROUTE[serviceAlias]?.filter(v => v?.showDevice?.includes(device)), []) : [];
    const data = useMemo(() => setTabData(route, alias, searchParams, serviceAlias), [searchParams]);
    
    return device === DEVICE_TYPE.MOBILE || !isPcWidth ? <SwiperTab data={data} /> : <GeneralTab data={data} className="tab-alias"/>; 
};